import React from "react";
import {CheckSquareOutlined, CloseSquareOutlined, BellOutlined, PhoneOutlined} from '@ant-design/icons';

export const findCompanyExt=(extern,extensions,userN)=>{

    for(let i  in extensions){
        const row = extensions[i];
       // console.log("renderPeerState > ",(userN.Role!=="super")," > ",row);
        if(row.Number===extern){
            //todo extern find
            let boo=true;
            if(userN.Role!=="super"){
                if(userN.Org!==row.Org){
                    boo=false
                }
            }
            return {
                CompanyCode:row.Org,
                Boo:boo
            }
        }
    }
    return{
        CompanyCode:"none",
        Boo:false
    }
}
export const findCompanyFromLineNumber=(lineNumber,lines,userN)=>{
    const cleanNumber=(phone)=>{
        let destination = "0" + phone.substring(phone.length - 9);
        return destination;
    }
    console.log("-:)- 55",lines)

    if(cleanNumber(userN.outbound)===cleanNumber(lineNumber)){
        return {
            CompanyCode:userN.Org,
            Boo:true
        }
    }


    /*for(let i in lines){
        let row =lines[i];
        console.log("-:)- ",cleanNumber(row.InboundNumber)," > ",cleanNumber(lineNumber),
            (cleanNumber(row.InboundNumber)===cleanNumber(lineNumber)))
        if(cleanNumber(row.InboundNumber)===cleanNumber(lineNumber)){

            let boo=true;
            if(userN.Role!=="super"){
                if(userN.Org!==row.Org){
                    boo=false
                }
            }
            return {
                CompanyCode:row.Org,
                Boo:boo
            }
        }
    }*/

    return{
        CompanyCode:"none",
        Boo:false
    }
}
export const  findCompanyNameFromCode=(code,companies)=>{
    for(let i in companies){
        const row=companies[i];
        if(row.CustomerNumber===code){
            return row.Name;
        }
    }
    return code;
}
export const  getAgentName = (extension,Extensions) => {
    for (let i in Extensions) {
        const row = Extensions[i];
        if (row.Number === extension) {
            return row.Agent
        }
    }
    return extension;
}
export const makerStateIcon = (text) => {
    if (text === "online") {
        return (
            <CheckSquareOutlined style={{color: "green", fontSize: 20, fontWeight: "bold"}}/>
        )
    } else {
        return (
            <CloseSquareOutlined style={{color: "red", fontSize: 20, fontWeight: "bold"}}/>
        )
    }
}
export const makerStateCallStep = (state) => {
    if (state === "RINGING" || state === "WAITING") {
        return (
            <BellOutlined style={{color: "orange", fontSize: 20, fontWeight: "bold"}}/>
        )
    }
    if (state === "ANSWER") {
        return (
            <PhoneOutlined style={{color: "green", fontSize: 20, fontWeight: "bold"}}/>
        )
    }
}

